import React from 'react';
import RenderProps from '../../helpers/RenderProps';
import { useTheme } from '../../../hooks/theme/useTheme';
import useInput from '../Input';

export enum ColorInputStructure {
  formInput = 'formInput',
  input = 'input',
}
export type Verify = Utils.VerifyExtends<Component.Input.Color.Structure, typeof ColorInputStructure>;
export default function ColorInput<Name>(props: Component.Input.Color.Import<Name>) {
  const extend = useTheme(ColorInputStructure, props);
  const { value, setValue } = useInput(props);
  return (
    <div
      {...extend(ColorInputStructure.formInput, true)}
      data-label={props.label}
      data-error={props.error || undefined}
      title={props.error ?? undefined}
      data-read-only={props.readOnly || undefined}
    >
      {RenderProps(props, 'iconBefore')}
      <input
        {...extend(ColorInputStructure.input)}
        type="color"
        autoComplete="off"
        readOnly={props.readOnly}
        value={value || ''}
        placeholder={props.placeholder || ' '}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => setValue(event.currentTarget.value)}
      />
      {RenderProps(props, 'icon')}
    </div>
  );
}
